import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'portfolio/Artboard 9@2x.png' satisfies MediaPath
const forecast = 'portfolio/Screen Shot 2016-04-30 at 8.10.06 PM.png' satisfies MediaPath
const poster = 'portfolio/gtd-poster.png' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'rgo',
	name: 'rgo',
	excerpt: 'A rowing companion — go / no-go at a glance',
	tags: ['code', 'design', 'data'],
	cover,
	order: 35,
	repo: 'https://github.com/eam/rgo',
}

export default function Rgo() {
	return (
		<>
			<h2 className="font-bold text-xl mt-0">Overview</h2>
			<p>
				rgo answers the only question that matters at 5 a.m. on the water: row or don't. It pulls
				live wind, temperature, and water conditions for the reservoir and renders a single,
				unambiguous verdict — then gets out of the way with shortcuts to just row, pick a piece, or
				review history.
			</p>
			<h2 className="font-bold text-xl">Conditions, not data dumps</h2>
			<p>
				An earlier build leaned on a full-bleed satellite map and a blunt call — “Probably Don't
				Row” — sitting over the morning's wind chill and gusts. The redesign keeps that honesty but
				trades the map for type, weather, and a verdict you can read half-awake.
			</p>
			<h2 className="font-bold text-xl">Going the Distance</h2>
			<p>
				A companion data-viz piece mapping a winter training block — every erg meter, split, and
				placing wound into a single radial poster.
			</p>
			<Gallery
				items={[
					{
						src: cover,
						alt: 'rgo — conditions home screen',
					},
					{
						src: forecast,
						alt: "Probably Don't Row — forecast verdict",
					},
					{
						src: poster,
						alt: 'Going the Distance — training poster',
					},
				]}
			/>
		</>
	)
}
